import React from 'react'
import { useQuery } from '@apollo/client'

import { ContentLoaderTableOnly } from '../../../components/loader/loader.component'
import TableComponent from '../../../components/table/table.component'
import LabelComponent from '../../../components/label/label.component'
import LinkComponent from '../../../components/link/link.component'

import { ActionContainer, SortingContainer } from '../admin.styles'

import { GET_TRANSACTION_LIST } from '../../../config/graphql'

const DepositList = ({ dateRange, groupFilter }) => {
    console.log({ variables: {...dateRange, ...groupFilter} })
    const { loading, data } = useQuery(GET_TRANSACTION_LIST, { variables: {...dateRange, ...groupFilter} });
    console.log(data);
    const dataDeposit = data?.transactions || [];
    console.log(dataDeposit);
    const shop = {
      'f9820b438003d067': 'Toko 1',
      '066af79ca410ac02': 'Toko 2',
      '6e1e695aab6091bc': 'Stationery',
      null: 'Stationery'
    };

    if (loading && !dataDeposit.length) {
      return <ContentLoaderTableOnly />
    } else {
      var idx = 0;
      let currency = Intl.NumberFormat('id', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      var grouped = Map.groupBy(dataDeposit, ( row )=> (row['action']['name']))
      var obj = {}
      Array.from(grouped, (key) => {
        obj[key[0]] = key[1].reduce((a, b) => {
          return a + b['amount'];
        }, 0);
      });
      var total = Object.keys(obj).reduce((string, key, index)=> {
        if(index > 0) string += ', '
        string += `${key}: ${currency.format(obj[key])}`
        return string;
      }, '');
      return <div style={{marginTop: '2em'}}>
        <div style={{fontSize: '1.2em', fontWeight: 'bold'}}>{total}</div>
        <TableComponent mode='custom' template='1fr 3fr 2fr 2fr 1fr 2fr 2fr 3fr 2fr'>
          <div aria-label='head'>
            <div>
              <SortingContainer>No</SortingContainer>
            </div>
            <div>
              <SortingContainer>Tanggal</SortingContainer>
            </div>
            <div>
              <SortingContainer>Nama</SortingContainer>
            </div>
            <div>
              <SortingContainer>Murid/Staff</SortingContainer>
            </div>
            <div>
              <SortingContainer>Kelas</SortingContainer>
            </div>
            <div>
              <SortingContainer>Tipe</SortingContainer>
            </div>
            <div>
              <SortingContainer>Jumlah</SortingContainer>
            </div>
            <div>
              <SortingContainer>ID Kasir</SortingContainer>
            </div>
            <div>
              <SortingContainer>Toko</SortingContainer>
            </div>
          </div>
          <div aria-label='body'>
            {dataDeposit.map((deposit) => {
                idx++;
                return (
                  <div key={idx}>
                    <div>
                      <LabelComponent mode='tagredmobile'>NO</LabelComponent>
                      {idx}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Tanggal</LabelComponent>
                      {(new Date(Date.parse(deposit.createdAt))).toLocaleDateString('id', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} - {(new Date(Date.parse(deposit.createdAt))).toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' })}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Nama</LabelComponent>
                      {(deposit.account.user.name)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Murid/Staff</LabelComponent>
                      {deposit.account.user.kind == 'guru' ? 'Staff' : 'Murid'}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Kelas</LabelComponent>
                      {deposit.account.user.classroom ? deposit.account.user.classroom.name : null}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Nama</LabelComponent>
                      {(deposit.action.name)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Jumlah</LabelComponent>
                      {(currency.format(deposit.amount))}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>ID KASIR</LabelComponent>
                      {deposit.deviceId}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Toko</LabelComponent>
                      {deposit.foodVendor ? deposit.foodVendor.name : shop[deposit.deviceId] }
                    </div>
                  </div>
                )
            })}
          </div> 
        </TableComponent>
      </div>
    }
}

export default DepositList;